import React from 'react';

interface CompleteStepProps {
  proxy: any;
  onFinish: () => void;
  onViewProxy: () => void;
}

const CompleteStep: React.FC<CompleteStepProps> = ({ 
  proxy, 
  onFinish, 
  onViewProxy 
}) => {
  return (
    <div className="card shadow">
      <div className="card-body text-center py-5">
        <div className="mb-4">
          <i className="fas fa-check-circle text-success" style={{ fontSize: '4rem' }}></i>
        </div>

        <h3 className="mb-3">MCP Proxy Created Successfully!</h3>

        <p className="text-muted mb-4">
          Your MCP Proxy <strong>{proxy?.name}</strong> has been created and is now active.
        </p>

        <div className="alert alert-info mx-auto" style={{ maxWidth: '500px' }}>
          <h6 className="font-weight-bold mb-2">
            <i className="fas fa-info-circle mr-2"></i>
            Next Steps
          </h6>
          <ul className="text-left mb-0 small">
            <li>The MCP Proxy is now running and ready to use</li>
            <li>Agents can access your API through MCP tools</li>
            <li>You can view and manage this proxy from the MCP Proxies page</li>
          </ul>
        </div>

        <div className="mt-4">
          <button
            className="btn btn-primary mr-2"
            onClick={onFinish}
          >
            <i className="fas fa-list mr-1"></i>
            View All MCP Proxies
          </button>
          <button
            className="btn btn-outline-secondary"
            onClick={onViewProxy}
          >
            <i className="fas fa-eye mr-1"></i>
            View This Proxy
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompleteStep;
